import {FormProvider, useForm} from "react-hook-form";
import {useEffect} from "react";
import {useSelector} from "react-redux";
import Modal from "@/components/common/Modal";
import RefundDetail from "@/pages/Refund/Detail";
import {RootState, useAppDispatch} from "@/store";
import {refundDetailActions} from "@/store/refund-detail/slice";
import {getRefundDetail} from "@/store/refund-detail/action";
import ModalFooter from "@/pages/Refund/ModalFooter";
import {getUserVenues} from "@/store/user-info/action";
import {getInvoiceDetail} from "@/store/invoice/action";
import Refund from "@/pages/Refund/index";

const initialRefundValue = {
  note: '',
  status: 'CREATED',
  total_price: 0,
  is_manual_input: false,
  details: [],
  customer_info: {
    account_name: '',
    bank_code: '',
    account_number: ''
  }
} as Refund

const RefundModal = () => {
  const refundDetailMethods = useForm({
    defaultValues: initialRefundValue
  })
  const dispatch = useAppDispatch()
  const { refund, modal } = useSelector((rootState: RootState) => rootState.refundDetail.state)
  const {
    show,
    currentId
  } = modal

  const getRefundDetailData = () => {
    if (!currentId || !show) {
      return
    }
    dispatch(getRefundDetail(currentId)).then((response) => {
      const refundData = response.payload as Refund
      dispatch(getInvoiceDetail(refundData.invoice_id))
    })
  }

  useEffect(() => {
    refundDetailMethods.reset(refund)
  }, [refund])

  useEffect(() => {
    getRefundDetailData()
  }, [currentId])

  const closeModal = () => {
    dispatch(refundDetailActions.showRefundDetailModal({
      show: false,
      id: null
    }))
  }

  useEffect(() => {
    dispatch(getUserVenues({}))
  }, [])

  return (
    <FormProvider {...refundDetailMethods}>
      <Modal
        show
        contentClassName="basis-[500px]"
        header={{title: currentId ? 'Edit Refund' : 'Add Refund'}}
        body={{children: <RefundDetail/>}}
        footer={{children: <ModalFooter/>}}
        onClick={() => closeModal}
        rootId="refund-detail-form"
      />
    </FormProvider>
  );
};

export default RefundModal;